// import { useState } from "react"
import me from "./images/me.jpg"
export default function About(props) {



    // const [myStyle, setMyStyle] = useState({
    //     color: 'white',
    //     backgroundColor: 'black',
    // })

    // const [btnText, setBtnText] = useState('Enable Light Mode');

    // const toggleStyle = () => {
    //     if (myStyle.color === "white") {
    //         setMyStyle({
    //             color: 'black',
    //             backgroundColor: 'white',
    //         })
    //         setBtnText("Enable Dark Mode");


    //     } else {
    //         setMyStyle({
    //             color: 'white',
    //             backgroundColor: 'black',
    //             border: '2px solid white',

    //         })
    //         setBtnText("Enable Light Mode")

    //     }
    // }

    return (
        <>
            <div className='container ' >
                <h2 className='container'>About Us</h2>
                <div className="accordion container p-1 rounded-2" id="accordionExample"  >
                    <div className="accordion-item" >
                        <h2 className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse"  data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                About Txt Convert
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <p className="text-capitalize" style={{ color: props.theme === 'dark' ? 'white' : 'black' }}>
                                    <span className="fw-bold">Txt Converter : </span>
                                    is a text convert web based application.that converter your text into uppercase to lowercase or lower to uppercase or capitalize your text and also remove your extra spaces from your text in few second
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item" >
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Founder Of Txt Converter
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <div class="card">
                                    <img src={me} className="w-25 h-25 card-img-top" alt="..." />
                                    <div class="card-body">
                                        <p class="card-text">As a full stack web developer, my name is Shohan and I thrive on transforming innovative ideas into functional and visually appealing web applications. With a strong passion for coding and problem-solving, I have honed my skills to deliver seamless user experiences and create efficient backend systems.

                                            With several years of experience in the industry, I have acquired a diverse range of technical expertise. From designing intuitive user interfaces using HTML, CSS, and JavaScript, to developing robust server-side applications with frameworks like Node.js and Django, I am well-versed in the entire web development stack.

                                            My journey as a developer has taught me the value of collaboration and effective communication. I believe in working closely with clients and stakeholders to understand their unique requirements and translate them into scalable solutions. My attention to detail and commitment to delivering high-quality code ensure that projects are completed on time and exceed expectations.

                                            Furthermore, I am always eager to stay up-to-date with the latest technologies and industry trends. This allows me to incorporate cutting-edge tools and frameworks into my workflow, enabling me to provide innovative and efficient solutions to complex challenges.

                                            In addition to technical skills, I possess strong problem-solving abilities, a creative mindset, and a dedication to continuous learning. I thrive in dynamic environments where I can contribute my expertise while embracing new opportunities for growth.

                                            Overall, my passion for web development, combined with my technical proficiency and collaborative mindset, makes me a valuable asset in creating impactful and engaging web applications. I am excited to embark on new projects and contribute to the ever-evolving world of technology.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item" >
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Contact Us
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classNamees that we use to style each element. These classNamees control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div>   
                <button onClick={toggleStyle}>
                    {btnText}
                </button>
            </div> */}

        </>
    )
}
